module.exports = __webpack_public_path__ + "img/duixiu01.5892b82f.png";